var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},_vm._l((_vm.dataSource.detail),function(item,index){return _c('Detail',{key:index,attrs:{"dataSource":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }